// extracted by mini-css-extract-plugin
export default {"wrapper":"Block_wrapper__aVq64","number":"Block_number__2yf0a","description":"Block_description__4AxTt","tooltip":"Block_tooltip__a-9aB","ani":"Block_ani__wmF+i"};